import React from "react";

const APropos = () => {
  return (
    <section className="bg-[#F7F4EF] pt-40 md:pt-48 pb-24 md:pb-32" data-nav-theme="light">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16 md:mb-20">
          <div className="md:col-span-6">
            <h1
              className="font-display uppercase text-neutral-900 leading-[0.95]"
              style={{ fontSize: "clamp(38px, 5vw, 84px)" }}
            >
              À propos de Maison Labroca
            </h1>
          </div>

          <div className="md:col-span-6 space-y-6 text-[15px] md:text-[16px] leading-relaxed text-neutral-700">
            <p>
              Entreprise familiale fondée en 2004. Notre équipe conjugue
              savoir-faire, exigence et relation humaine pour donner vie à vos
              projets.
            </p>
            <p>
              Spécialisés dans la construction résidentielle et tous types de
              rénovations, nous accompagnons nos clients dans la création et la
              transformation de leurs espaces de vie avec un engagement fort
              envers la qualité et le savoir-faire.
            </p>
            <p>
              En tant qu'entreprise familiale, nous croyons qu'une maison est
              bien plus qu'un simple bâtiment : elle est le fondement de
              l'histoire de votre famille. C'est pourquoi nous plaçons une
              approche humaine personnalisée, la transparence et une expertise
              fiable au cœur même de notre philosophie.
            </p>

            <div>
              <p className="font-medium text-neutral-900 mb-3">Nos domaines d'expertise :</p>
              <ul className="space-y-2">
                <li className="flex gap-3">
                  <span className="text-[#9F8B76] mt-1">—</span>
                  <span>
                    <span className="text-neutral-900 font-medium">Construction clé en main :</span>{" "}
                    prise en charge complète de vos projets de maisons neuves
                    sur mesure, adaptées à vos besoins.
                  </span>
                </li>
                <li className="flex gap-3">
                  <span className="text-[#9F8B76] mt-1">—</span>
                  <span>
                    <span className="text-neutral-900 font-medium">Programmes immobiliers & Collectifs :</span>{" "}
                    lotissements et petits collectifs, pour investisseurs et
                    promoteurs.
                  </span>
                </li>
                <li className="flex gap-3">
                  <span className="text-[#9F8B76] mt-1">—</span>
                  <span>
                    <span className="text-neutral-900 font-medium">Tous types de rénovations :</span>{" "}
                    rénovation globale, modernisation et amélioration de
                    l'habitat, qu'il s'agisse de projets partiels ou complets.
                  </span>
                </li>
              </ul>
            </div>

            <p>
              Notre signature ? Allier le savoir-faire traditionnel à une
              gestion de projet rigoureuse pour donner vie à vos projets
              résidentiels de manière fluide et professionnelle.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default APropos;
